import { Outlet } from 'react-router';
import React from "react";
import muiTheme from './theme/renuTheme';
import * as theme from './theme';
import './theme/renuStyle.css';
import { ThemeProvider } from '@mui/material';

function RenuLayout() {

  return (
    <ThemeProvider theme={muiTheme}>
      <div className="app" style={{ marginTop: 0, marginLeft: 20, marginRight: 20, marginBottom: 20 }}>
        <div style={{ ...theme.Container.basic, ...theme.Container.centeredViewport, color: theme.Colors.White, width: '100%' }}>
          <Outlet />
          <div style={{ ...theme.Container.flexCenter }}>
            
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default RenuLayout;
